module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "activity-detail-top"
  }, [_c('div', {
    staticClass: "top-info"
  }, [_c('div', {
    staticClass: "info-top-box"
  }, [_c('div', {
    staticClass: "activity-detail-title"
  }, [_vm._v(_vm._s(_vm.cate_row.name))]), _vm._v(" "), _c('div', {
    staticClass: "activity-detail-desc"
  }, [_vm._v(_vm._s(_vm.cate_row.s_name))])])])]), _vm._v(" "), _c('van-pull-refresh', {
    on: {
      "refresh": _vm.onRefresh
    },
    model: {
      value: (_vm.isLoading),
      callback: function($$v) {
        _vm.isLoading = $$v
      },
      expression: "isLoading"
    }
  }, [_c('van-list', {
    attrs: {
      "finished": _vm.finished,
      "finished-text": "没有更多了"
    },
    on: {
      "load": _vm.onLoad
    },
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  }, _vm._l((_vm.list), function(item, key) {
    return _c('div', {
      key: key,
      staticClass: "sai-itmes"
    }, [_c('div', {
      staticClass: "items-top1"
    }, [_c('div', {
      staticClass: "train-items-top show-two-row",
      style: ('background-image:linear-gradient(to right, rgb(43, 122, 255), rgb(30, 178, 255));')
    }, [_c('div', {
      staticClass: "sai-type-tip"
    }, [_vm._v("国际")]), _vm._v(" "), _c('div', {
      staticClass: "train-items-top-city"
    }, [_vm._v(_vm._s(_vm.cate_row.name))]), _vm._v(" "), _c('div', {
      staticClass: "train-items-top-time"
    }, [_vm._v(_vm._s(item.jingwai_start_time) + " ")])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "text-align": "center",
        "margin-top": ".1rem"
      }
    }, [_vm._v("\n                " + _vm._s(item.jingwai_baoming_end) + "开始报名\n              ")])]), _vm._v(" "), _c('div', {
      staticClass: "sai-info-box",
      staticStyle: {
        "flex": "1"
      }
    }, [_c('p', {
      staticClass: "sai-title show-two-row"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "items-btn"
    }, [_c('div', {
      directives: [{
        name: "rblink",
        rawName: "v-rblink",
        value: ({
          name: 'NewsDetail',
          query: {
            id: item.jingwai_tongzhi_id
          }
        }),
        expression: "{name:'NewsDetail',query:{id:item.jingwai_tongzhi_id}}"
      }],
      staticClass: "sai-into"
    }, [_vm._v("通知文件\n                ")])])])])
  }), 0)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0e211628","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/page/GuojijiaoliuDetail.vue
// module id = 2213
// module chunks = 0